import { Outlet } from "react-router-dom";

export const SettingsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
